import { Box } from '@material-ui/core';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import {
  FetchWsCatalogueProductTypes,
  fetchWsCatalogueProducts,
  handleCloseWsCatalogueSideMenu,
} from '@src/reducers/wsCatalogue';
import {
  getWsCatalogueError,
  getWsCatalogueShoppingCartDetail,
} from '@src/selectors/wsCatalogue';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorView } from './ErrorView';
import { OrderItem } from './OrderItem';
import { OrderSummary } from './OrderSummary';
import { WSCatalogueShoppingCartDetail } from './types';

const OrderDetailsWrapper: React.FC = () => {
  const dispatch = useDispatch();
  const shoppingCartDetail = useSelector(getWsCatalogueShoppingCartDetail);
  const error = useSelector(getWsCatalogueError);

  if (!shoppingCartDetail) return null;

  const handleClickOnProduct = (id: string) => {
    const { catalogId } = shoppingCartDetail;
    dispatch(
      fetchWsCatalogueProducts({
        retailerIds: id,
        catalogId,
        type: FetchWsCatalogueProductTypes.PRODUCT,
      })
    );
  };

  return (
    <OrderDetails
      {...shoppingCartDetail}
      error={error}
      handleClose={() => dispatch(handleCloseWsCatalogueSideMenu())}
      handleClickOnProduct={handleClickOnProduct}
    />
  );
};

export const OrderDetails: React.FC<
  WSCatalogueShoppingCartDetail & {
    error?: boolean;
    handleClose: () => void;
    handleClickOnProduct: (id: string) => void;
  }
> = ({
  products,
  totalPrice,
  totalPriceCurrencySymbol,
  date,
  error,
  handleClickOnProduct,
  handleClose,
}) => {
  const getTotalPrice = () => {
    if (!totalPrice) return undefined;
    return `${totalPriceCurrencySymbol || ''} ${totalPrice}`;
  };
  return (
    <Box padding="0px 16px 10px">
      <Box
        width="100%"
        display="flex"
        justifyContent="right"
        onClick={handleClose}
        style={{ cursor: 'pointer', marginBottom: '30px' }}
      >
        <CancelOutlinedIcon />
      </Box>
      {error ? (
        <ErrorView type={FetchWsCatalogueProductTypes.CART} />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="calc(100vh - 220px)"
        >
          <Box
            mb="20px"
            display="flex"
            flexDirection="column"
            style={{ gap: '27px' }}
            overflow="auto"
          >
            {products.map(item => (
              <OrderItem
                key={item.id}
                name={item.name}
                price={item.price}
                images={item.images}
                totalItems={item.totalItems || 0}
                handleClick={() => handleClickOnProduct(item.id)}
              />
            ))}
          </Box>
          <OrderSummary date={date} totalPrice={getTotalPrice()} />
        </Box>
      )}
    </Box>
  );
};

export default OrderDetailsWrapper;
